<template>
  <div class="buyerdetails">
    <div class="text-xs-left subheading font-weight-bold ">Note to {{artistName}} (optional)</div>
    <v-form ref="form" v-model="valid" lazy-validation >
      <v-textarea
          solo
          v-model=note
          name="noteToSeller"
          placeholder="Optional message you can send with your order"
          hint="Optional message you can send with your order"
          :counter="0"
          :rules="noteRules"
          @blur="saveNote"
      >
      </v-textarea>
    </v-form>
</div>

</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'CommentsForSeller',
  data: function () {
    return {
      valid: true,
      noteRules: [
        v => (v && v.length <= 500) || 'Name must be less than 500 characters'
      ],
      note: null
    }
  },
  computed: {
    ...mapState({
      artistName: state => state.shopping.name,
      noteFromBuyer: state => state.cart.noteFromBuyer
    }),
  },
  mounted: function () {
    if (this.noteFromBuyer) {
      this.note = this.noteFromBuyer
    }
  },
  methods: {
    saveNote: function () {
      this.$store.commit('cart/setNote', this.note)
    },
    getData: function () {
      // Returns the form data
      return {
        note: this.note
      }
    },
    isValid: function () {
      return this.valid
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
